import { createReducer } from '@reduxjs/toolkit';

import getWarehouse from '../../../thunks/coilovers/warehouse/getWarehouse';
import { removeWarehousePart, setWarehouseParts } from '../../../actions/coilovers/warehouse/patchWarehouse';

const initialState = {
  loading: false,
  error: null,
  data: [],
  lastPage: undefined,
  currentPage: 1,
  total: 0
};

const getWarehouseReducer = createReducer(initialState, {
  [getWarehouse.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getWarehouse.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total 
    } 
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getWarehouse.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [removeWarehousePart]: (state, { payload: id }) => ({
    ...state,
    data: [
      ...state.data.filter(({ _id: sourceId }) => id !== sourceId)
    ]
  }),
  [setWarehouseParts]: (state, { payload }) => {
    const { _id: updateId } = payload;
    // eslint-disable-next-line no-underscore-dangle
    const updateData = state?.data?.map((item) => (item._id === updateId ? payload : item));
    return {
      ...state,
      loading: false,
      error: payload,
      data: updateData
    };
  },
});

export default getWarehouseReducer;
